export default {
  nights: 7,
  flexNights: true,
  adults: 2,
  childrenAges: [],
  dates: {
    startDate: null,
    endDate: null,
  },
  departure: 524901, // Москва
  destination: null,
};
